import { useState } from "react";
import { string, object } from "zod";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import * as routes from "../data/links/routes";
import { useAuth } from "../context/AuthContext";
import InputField from "../components/Inputs/InputField";
import { useGoogleReCaptcha } from "@google-recaptcha/react";
import PasswordField from "../components/Inputs/PasswordField";
import RequestButton from "../components/buttons/RequestButton";
import { handleReCaptchaVerify, captcha } from "../utils/helpers";
import { useNotifications } from "../context/NotificationContext";
import { StyledLink, SpacedRow, FormContainer } from "../data/style/Style";
import { DescriptionText, TwoTonedHeader } from "../components/theme/texts";

const passwordError = "Password must be between 10 to 20 characters.";
const userNameError = "Username is required.";

const Login = () => {
  let { loginMutation, activeRequest, setActiveRequest } = useAuth();
  const { executeV3 } = useGoogleReCaptcha();
  const [password, setPassword] = useState("");
  const [focusPw, setFocusPw] = useState(false);
  const [username, setUsername] = useState("");
  const [focusUsn, setFocusUsn] = useState(false);
  const { enableNotification } = useNotifications();

  const Credentials = object({
    username: string().trim().nonempty(userNameError),
    password: string().trim().min(10, passwordError).max(20, passwordError),
  });

  const input = {
    username,
    password,
  };

  const data = Credentials.safeParse(input);

  let handleLogin = async () => {
    if (!data.success) {
      enableNotification(data.error.issues[0].message, "error");
      return;
    }

    setActiveRequest(true);
    const token = await executeV3();
    await handleReCaptchaVerify(token, "login", document.cookie.split("=")[1]);
    if (captcha.success) {
      loginMutation.mutate(data.data);
    } else {
      setActiveRequest(false);
      enableNotification("Something went wrong. Please try again.", "error");
    }
  };

  return (
    <Stack gap={2} width={"50%"} alignItems={"center"}>
      <TwoTonedHeader mainText={"Log in"} fontSize={"clamp(36px,5.5vw,60px)"} />
      <DescriptionText style={{ fontSize: "clamp(14px,1.5vw,17px)" }}>
        Warm up and get ready to compete.
      </DescriptionText>
      <FormContainer>
        <div
          style={{
            height: 2,
            background:
              "linear-gradient(90deg,#f97316,#ea580c,rgba(249,115,22,.04))",
          }}
        />
        <Stack width={"90%"} p={5} gap={4} alignSelf={"center"}>
          <InputField
            id="gp-usn"
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onFocus={() => setFocusUsn(true)}
            onBlur={() => setFocusUsn(false)}
            focused={focusUsn}
          />
          <PasswordField
            id="gp-pw"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={() => setFocusPw(true)}
            onBlur={() => setFocusPw(false)}
            focused={focusPw}
            showToggle
          />
          <SpacedRow>
            <Link
              style={{ textDecoration: "none" }}
              to={routes.PASSWORD_RECOVER}
            >
              <StyledLink sx={{ fontSize: 12 }}>Forgot Password.</StyledLink>
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              to={routes.INDEX + "?register=true"}
            >
              <StyledLink sx={{ fontSize: 12 }}>Register</StyledLink>
            </Link>
          </SpacedRow>
          <RequestButton
            activeRequest={activeRequest}
            onClick={handleLogin}
            text={"Log in"}
            loadingText={"Logging..."}
            disabled={activeRequest}
          />
        </Stack>
      </FormContainer>
    </Stack>
  );
};
export default Login;
